import { Extension } from 'tiptap'
import store from "../../../store"
import CustomBoldMenuButton from './advancedEditingBtn'
// 自定义高级编辑组件
export default class TextHtml extends Extension {
    // get defaultOptions() {
    //     return {
    //         text: this.value,
    //     };
    //   }
    // here you can extend the extension like tiptap, such as schema, plugins ...
    get name() {
      return 'textHtml';
    }
    commands() {
      return (text) => (state, dispatch) => {
        if(this.options.updateHtml)
        {
          this.options.updateHtml(text);
        }
        //console.log(state.tr);
        //let tr = state.tr.insertText(text, 0, state.doc.content.size)
        //let tr = state.tr.insertHtml(text, 0, state.doc.content.size)
        // let te= "<h1>aa</h1>";
        // let tr = state.tr.insertText(te, 0, state.doc.content.size)
        // dispatch(tr);
        return true;
      };
    }
    menuBtnView ({ isActive, commands, focus, editor }) {
      return {
        component: CustomBoldMenuButton,
        componentEvents: {
          click: (text = '') => {
            commands.textHtml(text)
          },
        },
      };
    }
  }